/*
 * 分享相关的数据流
 */
//引入分享相关接口
import {
  getShareComponent,
  checkPassword,
  createShareTask,
  queryTaskByIdOfShare,
  editShareTask,
  getShareConfig,
  queryShareConfig,
  queryRandomNum,
  operationCondition,
  queryShareTask,
  queryShareTaskRecord,
  checkOnly,
  queryProjectRule,
  queryInsideDataSourceInfo,
  getServiceHallByServerId,
  getKnowledgeDetail,
  serviceHallGeneralConfig
} from "./../../api/share";
import request from "@/util/request";
//数据格式化相关方法
import { initTaskComponent } from "./../../util/projectFormatting";

const state = {
  fileNum:0
};
const mutations = {
  SET_FILE_NUM(state, num) {
    state.fileNum = num
  },};
const actions = {
  // 保存可上传附件数量
  setFileNum({ commit }, data){
    commit('SET_FILE_NUM',data)
  },
  //获取分享配置
  queryShareConfig({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryShareConfig(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面获取分享配置
  getShareConfig({ commit }, data) {
    return new Promise((resolve, reject) => {
      getShareConfig(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面获取组件
  getShareComponent({ commit }, data) {
    return new Promise((resolve, reject) => {
      getShareComponent(data)
        .then(res => {
          let response = {
            code: res.code
          };
          if (!res.code) {
            response.componentsCreate = initTaskComponent(res.data.create);
            response.componentsEdit = initTaskComponent(res.data.edit);
            response.componentsWatch = initTaskComponent(res.data.watch);
          }
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //校验分享密码
  checkPassword({ commit }, data) {
    return new Promise((resolve, reject) => {
      checkPassword(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面创建任务
  createShareTask({ commit }, data) {
    return new Promise((resolve, reject) => {
      createShareTask(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面编辑任务
  editShareTask({ commit }, data) {
    return new Promise((resolve, reject) => {
      editShareTask(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面查询任务
  queryTaskByIdOfShare({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryTaskByIdOfShare(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面获取密码随机数
  queryRandomNum({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryRandomNum(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面设置查询条件
  operationCondition({ commit }, data) {
    return new Promise((resolve, reject) => {
      operationCondition(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面根据条件查询任务
  queryShareTask({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryShareTask(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //分享页面根据条件查询任务-操作日志
  queryShareTaskRecord({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryShareTaskRecord(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  checkOnly({ commit }, data) {
    return new Promise((resolve, reject) => {
      checkOnly(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //获取工作表相关的配置规则：任务截止时间、组件显隐、组件计算
  queryProjectRule({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryProjectRule(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //获取内部数据源选项条件
  queryInsideDataSourceInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryInsideDataSourceInfo(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //根据服务大厅id获取服务大厅详情
  getServiceHallByServerId({ commit }, data) {
    return new Promise((resolve, reject) => {
      getServiceHallByServerId(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  //根据知识ID获取知识详情
  getKnowledgeDetail({ commit },data) {
    return new Promise((resolve, reject) => {
      getKnowledgeDetail(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 根据组件id获取关联子表单中的组件信息
  getColumnByIds(_, post) {
    return request.post("/v2/tableShare/column/getColumnByIds", post);
  },
  // 关联子表单自动拉取的值
  querySubForm(_, post) {
    return request.post("/v2/tableShare/task/querySubForm", post);
  },
// 获取关联子表单列表数据
  queryChildTask(_, post) {
    return request.post("/v2/tableShare/queryChildTask", post);
  },
  // 获取定制开发需求的权限
  queryRight(_, post) {
    return request.post("/v2/serviceHall/common/list", post);
  },
  serviceHallGeneralConfig({ commit },data) {
    return new Promise((resolve, reject) => {
      serviceHallGeneralConfig(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/share.js